import { motion } from "framer-motion";

// Intro-only variant of the Ascension crest: strokes draw themselves with a
// glow, stars ignite on springs. Same geometry as Crest.jsx — never redraw.
const EASE = [0.22, 1, 0.36, 1];

function draw(delay, duration) {
  return {
    initial: { pathLength: 0, opacity: 0 },
    animate: { pathLength: 1, opacity: 1 },
    transition: {
      pathLength: { duration, delay, ease: EASE },
      opacity: { duration: 0.01, delay },
    },
  };
}

const STARS = [
  {
    d: "M 33.02 13 L 31.67 16.74 L 27.69 16.87 L 30.83 19.31 L 29.73 23.13 L 33.02 20.9 L 36.31 23.13 L 35.21 19.31 L 38.34 16.87 L 34.37 16.74 Z",
    origin: "33px 16.5px",
  },
  {
    d: "M 48 9.4 L 46.65 13.14 L 42.67 13.27 L 45.81 15.71 L 44.71 19.53 L 48 17.3 L 51.29 19.53 L 50.19 15.71 L 53.33 13.27 L 49.35 13.14 Z",
    origin: "48px 13px",
  },
  {
    d: "M 62.98 13 L 61.63 16.74 L 57.66 16.87 L 60.79 19.31 L 59.69 23.13 L 62.98 20.9 L 66.27 23.13 L 65.17 19.31 L 68.31 16.87 L 64.33 16.74 Z",
    origin: "63px 16.5px",
  },
];

export default function IntroCrest({ size = 200 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      width={size}
      height={size}
      role="img"
      aria-label="Geskano"
    >
      <motion.path
        d="M 27.68 22 A 33 33 0 1 0 68.32 22"
        fill="none"
        stroke="#F4F6F2"
        strokeWidth="5"
        strokeLinecap="round"
        {...draw(0.55, 1.0)}
      />
      <motion.path
        d="M 26 57 L 45 42.5 M 70 57 L 51 42.5 M 30 67 L 45 54.5 M 66 67 L 51 54.5"
        fill="none"
        stroke="#F4F6F2"
        strokeWidth="7.5"
        strokeLinecap="round"
        {...draw(1.05, 0.85)}
      />
      {STARS.map((s, i) => (
        <motion.path
          key={i}
          d={s.d}
          fill="#E0A93B"
          style={{ transformOrigin: s.origin }}
          initial={{ opacity: 0, scale: 0.1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 260,
            damping: 12,
            delay: 1.65 + i * 0.16,
          }}
        />
      ))}
    </svg>
  );
}
